
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { UserMenu } from "@/components/UserMenu";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="w-full border-b border-border sticky top-0 left-0 right-0 z-50 bg-background">
        <div className="container mx-auto py-4 px-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <img
              src="/lovable-uploads/82002023-ce31-46c5-b6ce-14f9cdbffeaa.png"
              alt="Convergence Logo"
              className="w-8 h-8"
            />
            <Link to="/" className="text-xl font-semibold">
              Convergence
            </Link>
          </div>
          <UserMenu />
        </div>
      </header>

      <main className="container mx-auto py-8 px-4 flex-1">
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink>Terms of Service</BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <Card>
          <CardHeader>
            <CardTitle className="text-3xl">Terms of Service</CardTitle>
          </CardHeader>
          <CardContent className="prose prose-sm md:prose-base max-w-none text-left space-y-6">
            <p>Last updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="text-xl font-semibold">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Convergence, you agree to be bound by these Terms of Service. If you don't agree to these terms, please do not use the game.
            </p>
            
            <h2 className="text-xl font-semibold">2. Game Rules and Mechanics</h2>
            <p>
              Convergence is a word guessing game where players attempt to converge with AI on the same word. Players submit words and receive proximity scores indicating how close they are to the AI's chosen word. The game continues until either the player matches the AI's word or reaches the maximum number of attempts.
            </p>
            
            <h2 className="text-xl font-semibold">3. User Conduct</h2>
            <p>
              When using Convergence, you agree not to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Submit offensive, inappropriate, or harmful content</li>
              <li>Attempt to manipulate or exploit the game mechanics</li>
              <li>Use automated tools to play the game</li>
              <li>Interfere with other users' gameplay experience</li>
              <li>Reverse engineer or attempt to access the underlying word database</li>
            </ul>
            
            <h2 className="text-xl font-semibold">4. Intellectual Property</h2>
            <p>
              All content, features, and functionality of Convergence, including but not limited to the game design, logo, text, graphics, and code, are owned by Convergence and are protected by intellectual property laws.
            </p>
            
            <h2 className="text-xl font-semibold">5. Account Creation and Security</h2>
            <p>
              You may have the option to create an account to save your game progress and statistics. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
            </p>
            
            <h2 className="text-xl font-semibold">6. Game Availability and Modifications</h2>
            <p>
              We strive to keep Convergence available at all times, but we do not guarantee uninterrupted access. We reserve the right to modify, suspend, or discontinue the game, either temporarily or permanently, with or without notice.
            </p>
            
            <h2 className="text-xl font-semibold">7. Daily Challenges</h2>
            <p>
              Convergence may offer daily challenge modes where all players attempt to converge on the same word. These daily challenges reset at midnight in your local time zone.
            </p>
            
            <h2 className="text-xl font-semibold">8. Updates to Terms</h2>
            <p>
              We may update these Terms of Service from time to time. When we do, we will notify you by revising the "Last Updated" date at the top of this page. Your continued use of Convergence after such changes means you accept the new terms.
            </p>
            
            <h2 className="text-xl font-semibold">9. Contact Us</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at support@convergence-game.com.
            </p>
          </CardContent>
        </Card>
      </main>
      
      <Footer />
    </div>
  );
};

export default Terms;
